import { render, staticRenderFns } from "./OutstandingPoiQL.vue?vue&type=template&id=507fc0e8&scoped=true"
import script from "./OutstandingPoiQL.vue?vue&type=script&lang=js"
export * from "./OutstandingPoiQL.vue?vue&type=script&lang=js"
import style0 from "./OutstandingPoiQL.vue?vue&type=style&index=0&id=507fc0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fc0e8",
  null
  
)

export default component.exports